<template>
  <div class="attachcments">
    <button class="btn btn-success" @click.prevent="addFiles()" v-if="!filesAdd"><i class="fa fa-paperclip"></i></button>
    <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
    <h4 v-if="filesAdd">Archivos adjuntos</h4>
    <br>
    <table class="table" :style="`margin-top: 1rem; margin-bottom: 1rem; background: ${colorTable};`">
       <tbody>
        <tr v-for="(file, key) in files" class="file-listing" :key="key">
          <td>{{ file.name }}</td>
          <td v-if="!filesAdd"><span class="remove-file" @click.prevent="removeFile( key )"><i class="fa fa-trash"></i></span></td>
        </tr>
      </tbody>
    </table>
    <template v-if="files.length > 0 && !filesAdd">
      <small>Debe confirmar archivos para que puedan ser enviados en el correo</small>
      <div class="row text-right">
        <button class="btn btn-success" @click.prevent="submitFiles()">Confirmar archivo(s)</button>
      </div>      
    </template>
  </div>
</template>

<script>
export default {
  name: 'Attachments',
  props: ['formData'],
  computed: {
    formDataLocal: {
      get () {
        return this.formData
      },
      set (value) {
        this.$emit('update:formData', value)
      }
    },
  },
  data() {
    return {
      files: [],
      colorTable: '#b5b5b5',
      filesAdd: false
    }
  },
  methods: {
    addFiles(){
      this.$refs.files.click();
    },
    submitFiles(){
      for( var i = 0; i < this.files.length; i++ ){
        let file = this.files[i];
        this.formDataLocal.append('files[' + i + ']', file);
      }
      this.colorTable = 'white'
      this.filesAdd = true
    },
    handleFilesUpload(){
      let uploadedFiles = this.$refs.files.files
      for( var i = 0; i < uploadedFiles.length; i++ ){
        this.files.push( uploadedFiles[i] )
      }
    },
    removeFile( key ){
      this.files.splice( key, 1 );
    }      
  }
}
</script>

<style scoped>
  input[type="file"]{
    position: absolute;
    top: -500px;
  }

  div.file-listing{
    width: 200px;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
  }
</style>